import { GET_EVENTS_START, GET_EVENTS_END } from "./actionTypes";

export const fetchEvents = (params = {}) => ({
  type: GET_EVENTS_START,
  payload: params,
});

export const fetchEventsEnd = (data) => ({
  type: GET_EVENTS_END,
  payload: data,
});
